/**
 * Created by zangxiangming
 * Date: AD 2023/07/17
 * Time: 9:32
 * Description:
 */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import {JDScrollView,} from '@jdreact/jdreact-core-lib';
import { get, post } from '../../common/fetch';
import { NavBar, utils } from '@ltfe/ltfe-core-lib';
import { returnChange } from '../../config/protocol';
import { View } from 'react-native';
class refundChange extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showSignInfo: {}
        }
    }
    render() {
        const html = returnChange(this.state?.showSignInfo);
        if (!html) return null
        const source = { html };
        return (
          <>
              <NavBar title="退改签协议" />
              <JDScrollView
                style={ { padding: 15, backgroundColor: 'rgba(245,245,245,1)' } }
                keyboardDismissMode='on-drag'
                keyboardShouldPersistTaps='always'
                showsVerticalScrollIndicator={ false }>
                  <View dangerouslySetInnerHTML={{__html:html }} />
              </JDScrollView>
          </>
        )
    }
    getSignInfo() {
        get('movie_getSignInfo', {
            source: 1
        }, true).then((res)=> {
            // 显示弹窗条件, 已经签署过,并且没有勾选今日不再提醒;
            this.setState({ showSignInfo: res.data })
        })
    }
    componentDidMount() {
        this.getSignInfo()
    }
}
const select = () => {
    return {};
};
export default connect(select, null, null, { withRef: true })(refundChange);
